"use client";

import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';



export default function LoginPage() {
  const router = useRouter();
  const [identificador, setIdentificador] = useState('');
  const [senha, setSenha] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');
  const [verificandoSessao, setVerificandoSessao] = useState(true);

  const [isEsqueciModalOpen, setIsEsqueciModalOpen] = useState(false);
  const [recuperarId, setRecuperarId] = useState('');
  const [msgRecuperar, setMsgRecuperar] = useState('');
  const [erroRecuperar, setErroRecuperar] = useState('');

  useEffect(() => {
    const usuarioStr = localStorage.getItem('usuario');
    if (usuarioStr) {
      router.push('/painel');
    } else {
      setVerificandoSessao(false);
    }
  }, [router]);

  // Função para formatar dinamicamente como CPF se o usuário digitar apenas números
  const handleIdentificadorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    
    // Se possuir letras ou arroba, assumimos que o usuário está digitando um e-mail
    if (/[a-zA-Z@]/.test(val)) {
      // Se estava digitando um CPF (apenas números, pontos ou traços) e acabou de adicionar uma letra ou arroba
      if (/^[\d.-]+$/.test(identificador) && val.length === identificador.length + 1) {
        // Removemos a máscara automática (pontos e traços) aplicada anteriormente
        setIdentificador(val.replace(/[\.-]/g, ''));
      } else {
        setIdentificador(val);
      }
    } else {
      // Se não, formatamos com a máscara do CPF
      let formatado = val.replace(/\D/g, '');
      formatado = formatado.replace(/(\d{3})(\d)/, '$1.$2');
      formatado = formatado.replace(/(\d{3})(\d)/, '$1.$2');
      formatado = formatado.replace(/(\d{3})(\d{1,2})/, '$1-$2');
      setIdentificador(formatado.substring(0, 14));
    }
  };

  const handleRecuperarChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (/[a-zA-Z@]/.test(val)) {
      if (/^[\d.-]+$/.test(recuperarId) && val.length === recuperarId.length + 1) {
        setRecuperarId(val.replace(/[\.-]/g, ''));
      } else {
        setRecuperarId(val);
      }
    } else {
      let formatado = val.replace(/\D/g, '');
      formatado = formatado.replace(/(\d{3})(\d)/, '$1.$2');
      formatado = formatado.replace(/(\d{3})(\d)/, '$1.$2');
      formatado = formatado.replace(/(\d{3})(\d{1,2})/, '$1-$2');
      setRecuperarId(formatado.substring(0, 14));
    }
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault(); 
    setMensagem('');
    setErro('');

    try {
      const res = await fetch('https://api.arfainfo.com.br/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ identificador, senha })
      });

      const data = await res.json();

      if (data.sucesso) {
        setMensagem('Login realizado com sucesso! Redirecionando...');
        
        localStorage.setItem('usuario', JSON.stringify(data.usuario));
        if (data.token) {
          localStorage.setItem('userToken', data.token);
        }
        
        router.push('/painel');
      } else {
        setErro(data.mensagem || 'E-mail ou senha incorretos.');
      }
    } catch (err) {
      setErro('Erro de conexão com o servidor.');
    }
  };

  const handleEsqueciSenha = async (e: React.FormEvent) => {
    e.preventDefault();
    setMsgRecuperar('');
    setErroRecuperar('');

    try {
      const res = await fetch('https://api.arfainfo.com.br/api/esqueci-senha', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identificador: recuperarId })
      });
      const data = await res.json();
      if (data.sucesso) {
        setMsgRecuperar(data.mensagem);
      } else {
        setErroRecuperar(data.mensagem || 'Erro ao redefinir senha.');
      }
    } catch (err) {
      setErroRecuperar('Erro de conexão ao solicitar redefinição.');
    }
  };

  if (verificandoSessao) {
    return <div className="min-h-screen bg-[#e3e2de] flex items-center justify-center font-bold text-gray-500">Carregando...</div>;
  }

  return (
    <div className="cgt-root font-sans text-gray-900 flex flex-col justify-center min-h-screen py-12 sm:px-6 lg:px-8">
      <link href="https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Montserrat:ital,wght@0,400;0,600;0,700;0,800;0,900;1,400;1,800&display=swap" rel="stylesheet" />

      <div className="relative z-10 w-full">
        <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
          <a href="/" className="cgt-logo inline-flex mb-6">
            <img src="https://casadoguerreirotricolor.com.br/logo_pre.png" alt="Casa do Guerreiro Tricolor" className="w-16 h-16 object-contain" />
            <div className="cgt-logo-text">
              <span className="cgt-logo-text-1">Casa do</span>
              <span className="cgt-logo-text-2 cgt-title-font">GUERREIRO</span>
              <span className="cgt-logo-text-3">Tricolor</span>
            </div>
          </a>
          <h2 className="mt-2 text-center text-2xl font-black text-gray-800 uppercase italic tracking-tighter">
            Área do Guerreiro
          </h2>
          <p className="mt-2 text-center text-sm font-medium text-gray-500">
            Ainda não é sócio?{' '}
            <a href="/cadastro" className="font-bold text-[#8A1538] hover:text-[#5a0c23] transition underline decoration-2 underline-offset-2">
              Cadastre-se agora
            </a>
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-[#fdfdfd] py-8 px-6 shadow-[0_10px_25px_rgba(0,0,0,0.04)] sm:rounded-xl sm:px-10 border border-[#ddd]">
          {/* suppressHydrationWarning adicionado ao form */}
          <form className="space-y-6" onSubmit={handleLogin} suppressHydrationWarning>
            {erro && <div className="bg-red-50 text-red-700 p-3 rounded-lg text-sm font-medium border border-red-100">{erro}</div>}
            {mensagem && <div className="bg-green-50 text-green-700 p-3 rounded-lg text-sm font-medium border border-green-100">{mensagem}</div>}

            <div>
              <label htmlFor="identificador" className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">E-mail ou CPF</label>
              <input id="identificador" type="text" required value={identificador} onChange={handleIdentificadorChange} placeholder="joao@email.com ou 000.000.000-00" className="mt-1 appearance-none block w-full bg-white px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-[#006437] focus:border-[#006437] sm:text-sm tabular-nums" suppressHydrationWarning />
            </div>

            <div className="relative">
              <label htmlFor="senha" className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Senha</label>
              <input id="senha" type="password" required value={senha} onChange={(e) => setSenha(e.target.value)} className="mt-1 appearance-none block w-full bg-white px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-[#006437] focus:border-[#006437] sm:text-sm tracking-widest tabular-nums" suppressHydrationWarning />
              <button type="button" onClick={() => setIsEsqueciModalOpen(true)} className="absolute right-0 top-0 text-xs font-bold text-[#8A1538] hover:text-[#5a0c23] transition">Esqueci a senha</button>
            </div>

            <div>
              <button type="submit" className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-bold text-white bg-[#006437] hover:bg-[#004d2a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#006437] transition-colors uppercase tracking-wide">
                Entrar
              </button>
            </div>
          </form>
        </div>
        <div className="mt-8 text-center">
          <a href="/" className="text-xs font-bold text-gray-500 hover:text-gray-800 transition uppercase tracking-wider">
            ← Voltar para o Início
          </a>
        </div>
      </div>
    </div>

      {/* MODAL DE ESQUECI MINHA SENHA */}
      {isEsqueciModalOpen && (
        <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4">
          <div className="bg-[#fdfdfd] border border-[#ddd] rounded-xl shadow-2xl w-full max-w-md p-6 sm:p-8 relative">
            <button onClick={() => { setIsEsqueciModalOpen(false); setMsgRecuperar(''); setErroRecuperar(''); setRecuperarId(''); }} className="absolute top-4 right-6 text-gray-400 hover:text-gray-800 text-3xl font-light transition">&times;</button>
            <h2 className="text-2xl font-bold text-gray-800 mb-2 border-b pb-2">Recuperar Senha</h2>
            <p className="text-sm text-gray-600 mb-6">Informe seu E-mail ou CPF cadastrado para redefinir sua senha.</p>
            
            <form onSubmit={handleEsqueciSenha} className="space-y-5">
              {erroRecuperar && <div className="bg-red-50 text-red-700 p-3 rounded-lg text-sm font-medium border border-red-100">{erroRecuperar}</div>}
              {msgRecuperar && <div className="bg-yellow-50 text-yellow-800 p-4 rounded-lg text-sm font-medium border border-yellow-200">{msgRecuperar}</div>}

              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">E-mail ou CPF</label>
                <input type="text" required value={recuperarId} onChange={handleRecuperarChange} placeholder="joao@email.com ou 000.000.000-00" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#8A1538] focus:border-[#8A1538] tabular-nums" />
              </div>

              <div className="pt-2">
                <button type="submit" className="w-full bg-[#8A1538] text-white font-bold py-3 rounded-lg hover:bg-[#5a0c23] transition-colors uppercase tracking-wide text-sm shadow-sm">
                  Redefinir Senha
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
